import OwButton from "../OwButton/OwButton";
import "./OwBackToTop.scss";

type Props = {
    hasChangesBar: boolean;
};

export const OwBackToTop = (props: Props) => {
    const backToTop = () => {
        const scrollOptions: ScrollToOptions = {
            top: 0,
            left: 0,
            behavior: "auto",
        };

        const mainView = document.getElementById("mainView");

        if (mainView) {
            mainView.scrollTo(scrollOptions);
        }
    };

    return (
        <div data-testid={"back-to-top"} className={"OwBackToTop " + (props.hasChangesBar ? "hasChangesBar" : "")}>
            <OwButton
                testId={"back-to-top-btn"}
                name={"back_to_top"}
                className={"btn-transparent"}
                fn={backToTop}
                leftIconClass={"fas fa-arrow-up"}
                title={"back_to_top"}
            />
        </div>
    );
};
